import { z } from 'zod';

/** 従業員別明細タブ: 年月（未指定時は beforeLoad で最新月へリダイレクト） */
export const EmployeePaySlipDetailSearchSchema = z.object({
  year: z.coerce.number().int().min(2000).max(2100).optional(),
  month: z.coerce.number().int().min(1).max(12).optional()
});